import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';


class PrivacyPolicy extends Component {
  render() {
    const modalCloseButton = <div className="close-modal" onClick={this.props.onClickClose}></div>    
    return (
      <div>
        <Modal isOpen={this.props.visible} toggle={this.props.toggle} centered={true} className="get-started-modal"  modalClassName="get-started" external={modalCloseButton}>
          <div className="close-modal mobile" onClick={this.props.onClickClose}></div>
          <ModalBody className="terms-conditions">
            <h2>Credit bureau information</h2>       
            <div className="document-container">
              <div className="document">
                <p>By clicking ‘Submit Visa application’ below <b>I consent to Vancity obtaining and using credit and personal information about me from time to time (including a consumer or credit report) from any credit bureau or credit reporting agency, other financial institution or any reference I have provided, and disclosing, exchanging and confirming information with them on an ongoing basis in order to verify my identity and to assess my creditworthiness and make decisions about my application, including to accept or decline my application and determining the interest rate(s) applicable to my account and my credit limit.  Vancity will provide me with the name and address of the credit bureau or credit reporting agency upon request.</b></p>
              </div>
            </div>  
            <div className="button-container">
              <Button onClick={this.props.onClickClose} color="primary">Done</Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

PrivacyPolicy.defaultProps= {  
  visible: false,
};

PrivacyPolicy.propTypes = {
  visible: PropTypes.bool,
  onClickClose: PropTypes.func
};

export default PrivacyPolicy;


// WEBPACK FOOTER //
// ./src/components/Submit/PrivacyPolicy.js